import { render, staticRenderFns } from "./Tutorials.vue?vue&type=template&id=6cb847b3&"
import script from "./Tutorials.vue?vue&type=script&lang=js&"
export * from "./Tutorials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports